<template>
	<div v-show="pre_show" class="pre-label">
		<label class="pre-title">{{pre_item.name}}:</label>
		<div class="pre-html" :class="swichClass(pre_item)" v-html="pre_item.val">

		</div>




	</div>
</template>

<script>
	export default {
		name: "hj-text",
		data() {
			return {
				pre_item: {},
				pre_show: true
			}
		},
		props: {
			inData: {
				type: String,
				default: ''
			}
		},
		watch: {
			inData(val) {
				this.pre_item = {};
				this.pre_item = JSON.parse(this.inData);
				this.check_data();
			}
		},
		created() {
			this.pre_item = {};
			this.pre_item = JSON.parse(this.inData);
			// console.log(this.pre_item);
			this.check_data();
		},
		activated: function() {
			// console.log('keep-alive 组件激活时调用 hj-input激活');
			// console.log('激活',this.inData);
			this.pre_item = {};
			this.pre_item = JSON.parse(this.inData);
			this.check_data();
		},
		deactivated: function() {
			// console.log('keep-alive 组件激活时调用 hj-input停用');
			this.pre_item = {};
		},
		methods: {
			check_data: function() {
				let temp = '';
				temp = (this.pre_item.val).toString().replace(/\r\n/g, "<br/>");
				if (typeof(temp) === 'undefined' || temp == '') {
					this.pre_show = false;
				} else {
					this.pre_item.val = temp;
					this.pre_show = true;
				}
			},
			swichClass: function(item) {
				// console.log(item);
				let temp_class = item.class;
				// temp_class = String(temp_class).replace(' ', '')
				let back_class = '';

				switch (temp_class) {
					case 'black':
						back_class = 'pre-black';
						break;
					case 'red':
						back_class = 'pre-red';
						break;
					default:
						back_class = temp_class;
						break;
				}

				return back_class;

				// return {
				// 	"long1": temp_class === "long1",
				// 	"long1-2": temp_class === "long1-2",
				// 	"long2": temp_class === "long2",
				// 	"long3": temp_class === "long3",
				// 	"long4": temp_class === "long4",
				// 	"long5": temp_class === "long5",
				// 	"pre-black": temp_class === "black",
				// 	"pre-red": temp_class === "red"
				// };
			}
		}
	}
</script>

<style scoped="scoped">
	.pre-label {
		display: flex;
	}

	.pre-title {
		display: inline-flex;
		margin-right: 4px;
		min-width: 108px;
		justify-content: flex-end;
		
		align-items: center;
		line-height: 24px;
	}

	.pre-html {
		display: inline-flex;
		width: auto;
		text-align: left;
		align-items: center;
	}

	.pre-black {
		font-weight: bold;
	}

	.pre-red {
		font-weight: bold;
		color: #ff0000;
	}

	.pre-em {
		display: inline-block;
		vertical-align: middle;
		width: 10px;
	}

	.input-readonly {
		background-color: rgb(243, 243, 243);

	}

	.long1-2 {
		width: 168px;
	}
</style>